<script>
  export default {
    name: "Reservations",
    props: ['mainForm'],
    data () {
      return {
        form: this.mainForm,
        pagedata: {},
        pagelinks: '',
        reservations: [],
        showReservation: null
      }
    },
    mounted () {
        const vm = this

        $(window.document).on("click", ".pagination-reservations .page-link", function(e) {
            vm.call(e.target.href)
            return false
        })

        this.fetchReservations()
    },
    methods: {
        fetchReservations() {
            this.call('/users/' + this.form.id + '/reservations')
        }, 
        call(url) {
            let page = "1"
            const qsarr = url.split("?")
            if (qsarr.length === 2) {
                page = qsarr[1].replace("page=","")
            }

            if (this.pagedata[page]) {
                this.$set(this, 'reservations', this.pagedata[page].reservations.data)
                this.$set(this, 'pagelinks', this.pagedata[page].links)

                setTimeout(() => {
                    this.scrollOnTop()
                }, 200)
            } else {
                $("#spinner-modal").modal()

                axios({
                    method: 'get',
                    url: url
                }).then((response) => {
                    this.$set(this, "reservations", response.data.reservations.data)
                    this.$set(this.pagedata, response.data.reservations.current_page, response.data)
                    this.$set(this, 'pagelinks', response.data.links)

                    $("#spinner-modal").modal('hide')
                }).catch((error) => {
                    console.log(error)

                    window.alerts.error('Errore caricando i dati')

                    $("#spinner-modal").modal('hide')
                })
            }
        },
        formatDate(date) {
            return moment(date).format('DD/MM/YYYY')
        },
        formatTime(date) {
            return moment(date).format('LT')
        },
        calculateAge(birthday) {
            var from = moment(birthday).fromNow();
            return from.match(/\d+/)[0];
        },
        confirm(){
            axios({
                method: 'put',
                url: '/reservations/' + this.showReservation.id + '/confirm'
            }).then((response) => {
                window.alerts.success('Reservation confirmed');

                this.reservations.map((reservation)=>{
                    if(reservation.id === this.showReservation.id){
                        reservation.confirmed_by_user = 1;
                    }
                });

                this.showReservation = null;
            }).catch((error) => {
                window.alerts.error('Could not confirm reservation');
            });
        }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/user/Reservations.vue